export const FEATURE_CREATOR = 'editor/feature_creator';
export const PROJECT_SCOPE_SETUP = 'editor/project_scope_setup';
export const STONE_SETUP = 'editor/stone_setup';
export const FABRICATOR_PROFILE = 'editor/fabricator_profile';
export const PENDING_FEATURE_GROUP = 'editor/pending_feature_group';
export const INSTALLATION_CREATOR = 'editor/installation_creator';
export const INSTALLATION_GROUP = 'editor/installation_group';